import React from 'react';

import { HeadingLevel1 } from '@/components/shared/headline/heading-level-1';
import { Container } from '@/components/shared/layout/container';
import { Section } from '@/components/shared/layout/section';
import { Image } from '@/components/shared/media/image';
import { generateCommonImageSources } from '@/components/shared/media/image/generate-sources';
import { ImageProps } from '@/components/shared/media/image/Image.props';
import { IButton } from '@/types/shared';

export interface IServiceBanner {
  dataTestSection?: string;
  dataTrack?: string;
  title?: string;
  description?: string;
  buttons?: IButton[];
  imageMobile?: ImageProps;
  imageDesktop?: ImageProps;
}

const ServiceBannerSection: React.FC<IServiceBanner> = ({
  dataTrack = 'service-banner',
  dataTestSection = 'section_banner',
  ...props
}) => {
  return (
    <Section test={dataTestSection}>
      <HeadingLevel1
        title={props.title as string}
        description={props.description}
        buttons={props.buttons}
        dataTrack={dataTrack}
      />
      {!!props.imageMobile && !!props.imageDesktop && (
        <Container size="sm" maxWidth="none">
          <Image
            priority
            placeholder="shimmer"
            src={props.imageMobile.src}
            alt={props.imageMobile.alt}
            width={600}
            height={400}
            layout="responsive"
            aspectRatio={{ '@initial': '3by2', '@lg': '8by3' }}
            sources={generateCommonImageSources({
              mobileSrc: props.imageMobile.src,
              mobileOptions: {
                crop: '3:2',
              },
              desktopSrc: props.imageDesktop.src,
              desktopOptions: {
                crop: '8:3',
              },
            })}
          />
        </Container>
      )}
    </Section>
  );
};
ServiceBannerSection.displayName = 'ServiceBannerSection';
export default ServiceBannerSection;
